import React from 'react'
import Select from 'react-select';
const DrawbackDetails = () => {
    const basicDutyOpt = [{ value: 'chocolate', label: 'Chocolate' },
    { value: 'strawberry', label: 'Strawberry' },
    { value: 'vanilla', label: 'Vanilla' },];
    const basicUnit = [
        { value: 'Plus', label: 'Plus' },
        { value: 'Minus', label: 'Minus' },
        { value: 'Higher', label: 'Higher' },
        { value: 'Lower', label: 'Lower' },
    ]
    return (
        <div className='card'>
            <div className="card-body">
                <form>
                    <div className="row">
                        <div className="col-md-4">
                            <div className="mb-3">
                                <div className=" mb-1 d-flex justify-content-between align-items-center">
                                    <label htmlFor="name" className="form-label mb-0 text-label-red">
                                        Drawback Under
                                    </label>

                                </div>
                                <input
                                    type="text"
                                    className="form-control form-control-sm w-100"
                                    id="name"
                                    name="name"
                                // placeholder='Enter Branch Name'
                                />
                            </div>
                        </div>


                        <div className="col-md-4">
                            <div className="mb-3">
                                <div className=" mb-1 d-flex justify-content-between align-items-center">
                                    <label htmlFor="name" className="form-label mb-0 text-label-red">
                                        Drawback Sr No.
                                    </label>
                                </div>
                                <div className="d-md-flex justify-content-start align-items-center gap-2">
                                    <input
                                        type="text"
                                        className="form-control form-control-sm w-auto"
                                        id="name"
                                        name="name"
                                    />
                                    <Select
                                        className='custom-selector w-auto'
                                        options={basicDutyOpt}
                                    />
                                </div>
                                {/* {formik.touched.name && formik.errors.name ? (
<div className="error">{formik.errors.name}</div>
) : null} */}
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="mb-3">
                                <div className=" mb-1 d-flex justify-content-between align-items-center">
                                    <label htmlFor="name" className="form-label mb-0 text-label-red">
                                        Drawback Sr No.
                                    </label>
                                </div>
                                <div className="d-md-flex justify-content-start align-items-center gap-2">
                                    <input
                                        type="text"
                                        className="form-control form-control-sm w-auto"
                                        id="name"
                                        name="name"
                                    />
                                    <Select
                                        className='custom-selector w-auto'
                                        options={basicDutyOpt}
                                    />
                                </div>
                                {/* {formik.touched.name && formik.errors.name ? (
<div className="error">{formik.errors.name}</div>
) : null} */}
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="mb-3">
                                <div className=" mb-1 d-flex justify-content-between align-items-center">
                                    <label htmlFor="name" className="form-label mb-0 text-label-red">
                                        Drawback Rate
                                    </label>

                                </div>
                                <div className="d-md-flex justify-content-start align-items-center gap-2">
                                    <input
                                        type="text"
                                        className="form-control form-control-sm "
                                        id="name"
                                        name="name"
                                        defaultValue="0.00"
                                    />
                                    <div>%</div>
                                </div>
                                {/* {formik.touched.name && formik.errors.name ? (
<div className="error">{formik.errors.name}</div>
) : null} */}
                            </div>
                        </div>


                        <div className="col-6">
                            <div className="mb-3">
                                <div className=" mb-1 d-flex justify-content-between align-items-center">
                                    <label htmlFor="name" className="form-label mb-0 text-label-red">
                                        Cap Value
                                    </label>

                                </div>
                                <div className="d-md-flex justify-content-start align-items-center gap-2">
                                    <input
                                        type="text"
                                        className="form-control form-control-sm "
                                        id="name"
                                        name="name"
                                        defaultValue="0.00"
                                    />
                                    /
                                    <div> Unit </div>
                                </div>
                                {/* {formik.touched.name && formik.errors.name ? (
<div className="error">{formik.errors.name}</div>
) : null} */}
                            </div>
                        </div>
                    </div>

                    <div className="row justify-content-end mt-3 gap-2">
                        <button className="btn btn-primary text-xs w-fit" type="submit" >
                            Save
                        </button>
                        <button className="btn btn-primary text-xs w-fit" type="submit" >
                            Save & Close
                        </button>
                        <button className="btn btn-primary text-xs w-fit" type="submit" >
                            Save & New
                        </button>
                        <button className="btn btn-primary text-xs w-fit" type="submit" >
                            Close
                        </button>

                    </div>


                </form>
            </div>
        </div>
    )
}

export default DrawbackDetails